import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import SaleReconciliationReport from './SaleReconciliationReport';
import InvestorReconciliationReport from './InvestorReconciliationReport';
import CoinvestorReconciliationReport from './CoinvestorReconciliationReport';
import GroupReconciliationReport from './GroupReconciliationReport';
import LandlordReconciliationReport from './LandlordReconciliationReport';

ReconciliationReport.propTypes = {};

function ReconciliationReport(props) {
    return (
        <div>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="sale/*" element={<SaleReconciliationReport />} />
                    <Route path="investor/*" element={<InvestorReconciliationReport />} />
                    <Route path="coinvestor/*" element={<CoinvestorReconciliationReport />} />
                    <Route path="group/*" element={<GroupReconciliationReport />} />
                    <Route path="landlord/*" element={<LandlordReconciliationReport />} />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </div>
    );
}

export default ReconciliationReport;
